<template>
    <v-container>
        <v-card>
            <v-card-title>
                Acceso a Cuentas
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="searchUsers"
                    append-icon="mdi-magnify"
                    label="Buscar usuarios"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="searchAccounts"
                    append-icon="mdi-magnify"
                    label="Buscar cuentas"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :options="options"
                :items="filteredUsers"
                item-key="username"
                :items-per-page="20"
                :footer-props="{
                    'items-per-page-options' : [20, 40, -1]
                }"
                show-expand
                :expanded.sync="expandedUsers"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                    </v-toolbar>
                </template>
                <!-- 
                     <template v-slot:top>
                     <v-btn @click="importAccounts">
                     Importar Cuentas
                     </v-btn>
                     <v-btn @click="debug">
                     <v-icon>mdi-bug-outline</v-icon>
                     </v-btn>
                     </template>
                -->
                <!-- Account Checkboxes -->

                <template
                    v-for="(checkboxSlot, index) in checkboxSlots"
                    v-slot:[checkboxSlot.slotId]="{ item }"
                >
                    <!-- :ripple="false" or else we get [Vue warn]: Failed to resolve directive: ripple -->
                    <v-simple-checkbox
                        :key="index"
                        v-model="item[checkboxSlot.checkboxId]"
                        :ripple="false"
                        @input="toggleAccount( item, checkboxSlot.loginId )"
                    >
                    </v-simple-checkbox>
                </template>

                <!-- Expanded user information -->
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        {{ expandedUserInformation( item ) }}
                    </td>
                </template>

            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>

import { Hub } from 'aws-amplify';

import { mapGetters, mapActions } from 'vuex';

import { apiUpdateUser } from '@/users.js'

import { compareAccounts } from '@/view-accounts-tool.js';

const R = require( 'ramda' );

const {
    append,
    chain,
    curry,
    concat,
    filter,
    groupBy,
    has,
    includes,
    // innerJoin,
    join,
    map,
    merge,
    mergeAll,
    pipe,
    prop,
    // propEq,
    sort,
    tap,
    toString,
    toUpper,
    without,
} = R;


////////////////////////////////////////////////////////////////////////////////////////////////////
// GUI

const makeCheckboxId = concat( 'checkbox-' );

const makeCheckboxState = curry( ( state, loginId ) => ({
    checkboxId : makeCheckboxId( loginId ),
    state,
}) );

const addUserAccountCheckboxState = curry( ( accounts, user ) => {
    const unpackCheckboxState = state => ({ [state.checkboxId] : state.state });

    const blanks = map( pipe( prop( 'loginId' ), makeCheckboxState( false ), unpackCheckboxState ),
                        accounts );

    const nonblanks = map( pipe( makeCheckboxState( true ), unpackCheckboxState ),
                           user.tndAccountLoginIds );

    return mergeAll( append( user, concat( blanks, nonblanks ) ) );
} );

const dump = tap( pipe( tap( console.log ), toString, console.log ) );
dump;

export default {
    name: 'UserAccountAdministrationView',

    data : () => ({
        globalState : {},
        searchUsers : '',
        searchAccounts : '',
        expandedUsers : [],
        options : {
            sortBy : ['name'],
            multiSort : true,
        },
    }),

    created() {
        this.globalState = this.$root.$data.globalState;
        Hub.listen( 'monitor', data => {
            if ( ['ev:setAccount'].includes( data.payload.event ) )
                this.fetchUsers();
        } );
        this.apiSubscribeToUserEvents();
        this.apiSubscribeToTndAccountEvents();
        this.fetchUsers();
    },

    destroyed() {
    },

    mounted() {
    },

    computed : {
        ... mapGetters( {
            storeUsers : 'getUsers',
            getTndAccounts : 'getTndAccounts',
        } ),

        unfilteredUsers() {
            return map( addUserAccountCheckboxState( this.unfilteredTndAccounts ),
                        this.storeUsers );
        },

        filteredUsers() {
            const filterUser = user => {
                const searchString = toUpper( toString( user ) );

                // console.log( { searchString, searchUsers : this.searchUsers, indexOf : searchString.indexOf( toUpper( this.searchUsers ) ) !== -1 } );
                return searchString.indexOf( toUpper( this.searchUsers ) ) !== -1;
            };

            return filter( filterUser, this.unfilteredUsers );
        },

        unfilteredTndAccounts() {
            return sort( compareAccounts, this.getTndAccounts );
        },

        filteredTndAccounts() {
            const filterAccount = account => {
                const searchString = join(
                    '',
                    map( toUpper, map( property => prop( property, account ),
                                       ['location', 'description', 'loginId' ] ) )
                );

                return toUpper( searchString ).indexOf( toUpper( this.searchAccounts ) ) !== -1;
            };

            return filter( filterAccount, this.unfilteredTndAccounts );
        },

        tndAccountIds() {
            return map( prop( 'loginId' ), this.filteredTndAccounts );
        },

        checkboxIds() {
            return map( makeCheckboxId, this.tndAccountIds );
        },

        checkboxSlots() {
            const makeSlot = loginId => {
                const checkboxId = makeCheckboxId( loginId ),
                      slot = {
                          loginId,
                          slotId : `item.${checkboxId}`,
                          checkboxId
                      };

                return slot;
            };

            return map( makeSlot, this.tndAccountIds );
        },

        headers() {
            const createAccountHeader = tndAccount => ({
                text : tndAccount.location + ' ' + tndAccount.description,
                value : makeCheckboxId( tndAccount.loginId ),
            });

            return concat(
                [
                    { text : 'Nombre Completo', value : 'name',     },
                    // { text : 'Correo',          value : 'email' },
                    { text : 'Usuario',         value : 'username', },
                    // { text : 'Localidad',       value : 'city', groupable : true },
                    // { text : 'Compañía',        value : 'company' },
                    // { text : 'Departamento',    value : 'department' },
                    // { text : 'Cargo',           value : 'post' },
                    // { text : 'Teléfono',        value : 'phone' },
                ],
                map( createAccountHeader, this.filteredTndAccounts )
            );
        }, // headers

    },

    methods : {

        ... mapActions( [
            'apiListUsers',
            'apiSubscribeToUserEvents',
            'apiListTndAccounts',
            'apiSubscribeToTndAccountEvents',
        ] ),

        debug() {
            console.log( 'Debugging' );
            map( dump, [
                this.checkboxIds,
                this.checkboxSlots,
                this.filteredUsers
            ] );
        },

        expandedUserInformation( user ) {
            return `${user.name} ${user.company} ${user.department} ${user.post} ${user.city} ${user.phone} (${user.username}, ${user.email})`;
        },

        toggleAccount( user, loginId ) {
            // dump( { loginId, user } );

            const removeAccount = includes( loginId, user.tndAccountLoginIds );
            if ( removeAccount )
                user.tndAccountLoginIds = without( [loginId], user.tndAccountLoginIds ); // console.log( `Removing account ${loginId}` );
            else
                user.tndAccountLoginIds = append( loginId, user.tndAccountLoginIds ); // console.log( `Adding account ${loginId}` );
            apiUpdateUser( user );
        },

        importAccounts() {
            const extractUsers = account =>
                map( email => ({ email, loginId : account.loginId }), account.users );

            // {Array} => {Array}
            // tndAccounts => { email : [ loginId ] }
            const mapAccountsByUser = pipe(
                chain( extractUsers ),
                groupBy( prop( 'email' ) ),
                map( map( prop( 'loginId' ) ) ),
            );

            const accountsByEmail = mapAccountsByUser( this.unfilteredTndAccounts );

            const updateUser = user =>
                merge( user, { tndAccountLoginIds : accountsByEmail[ user.email ], } );

            const updateUsers = pipe(
                filter( user => has( user.email, accountsByEmail ) ),
                map( updateUser ),
                map( apiUpdateUser )
            );

            updateUsers( this.unfilteredUsers );
        }, // importAccounts

        async fetchUsers() {
            if ( ! this.globalState.account )
                return;

            await this.apiListUsers();
            await this.apiListTndAccounts()

        }, // fetchUsers
    },
}

</script>
